/**
 * Columnas admitidas por GET /api/v1/invoices (sorting[column]).
 * Orden por defecto enviado al API: id desc (sorting por `date` provoca error en el endpoint).
 */
export const INVOICES_SORTABLE_COLUMNS = [
  'id',
  'team_id',
  'shop_id',
  'erp_number',
  'erp_id',
  'date',
  'period_month',
  'parent_invoice_id',
  'reference_invoice_id',
  'base_total',
  'taxes_total',
  'grand_total',
  'pdf_url',
  'xml_url',
  'extra_data',
  'expired_at',
  'type',
  'preinvoice_id',
  'created_at',
  'updated_at',
] as const;

export type InvoicesSortableColumn = (typeof INVOICES_SORTABLE_COLUMNS)[number];

const SORTABLE_SET = new Set<string>(INVOICES_SORTABLE_COLUMNS);

/** Campo `field` de la grilla → columna del API (solo los que differen). */
export function invoiceGridSortFieldToApi(field: string): string {
  if (field === 'preinvoice_code') return 'preinvoice_id';
  return field;
}

export function normalizeInvoicesSortColumn(column: string | undefined): InvoicesSortableColumn {
  let resolved: InvoicesSortableColumn = 'id';
  if (column && SORTABLE_SET.has(column)) {
    resolved = column as InvoicesSortableColumn;
  }
  // El listado falla si se envía `date`; se usa `id` para la petición de ordenación.
  if (resolved === 'date') {
    return 'id';
  }
  return resolved;
}
